import type { IconSvgObject } from './types';

const WifiConnected02Icon: IconSvgObject = [
  ["path", { d: "M18.5 11.5C14.7324 8.16667 9.5 8.16667 5.5 11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 8C8.31579 2.66669 15.6842 2.66668 22 7.99989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 18L10.5 20L15.5 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default WifiConnected02Icon;
